import { Controller } from '@hotwired/stimulus'
import compact from 'lodash/compact'

export default class extends Controller {
  static targets = ['route', 'selectStationButton']

  changeRouteId () {
    const values = compact(this.routeTargets.map((checkbox) => checkbox.checked ? checkbox.value : null)).join(',')
    console.log(values)
    this.selectStationButtonTarget.dataset.url = this.element.dataset.stationsPath + '?route_ids=' + values
  }
}
